import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于天堂影视',
    description: '天堂影视是领先的电视剧免费在线观看平台，致力于为用户提供高清流畅的追剧体验。',
    url: 'https://www.tiantangyingshi.com/about',
    about: {
      '@type': 'Organization',
      name: '天堂影视',
      description: '天堂影视 - 电视剧全集免费在线观看平台',
      foundingDate: '2020',
    },
  };

  const stats = [
    { number: '10000+', label: '剧集资源' },
    { number: '500万+', label: '日活用户' },
    { number: '99.9%', label: '服务可用率' },
    { number: '7×24', label: '客服在线' },
  ];

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <article>
        <div className="w-full bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mt-3 font-heading">
                关于天堂影视
              </h1>
              <p className="text-sm text-foreground-400 mt-2">
                了解我们的品牌故事、核心价值观和联系方式
              </p>
            </div>
          </div>
        </div>

        <div className="w-full bg-background-50">
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14">
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    className="text-center p-5 rounded-lg bg-background-100 border border-background-200/70"
                  >
                    <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">
                      {stat.number}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-400">{stat.label}</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-14">
                <div>
                  <h2 className="text-xl font-bold text-foreground-900 font-heading mb-4">品牌故事</h2>
                  <div className="space-y-3">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      天堂影视创立于2020年，是领先的电视剧免费在线观看平台。我们的创始团队来自互联网和影视行业的资深从业者，怀揣着"让每个人都能免费看好剧"的初心，致力于打破付费壁垒，为广大追剧爱好者提供高品质的免费观影服务。
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      经过多年的技术积累和内容建设，天堂影视已发展成为国内领先的电视剧在线观看平台之一。我们拥有超过10000部电视剧资源，涵盖古装、都市、悬疑、甜宠、谍战、喜剧、奇幻等多种类型，满足不同用户的追剧需求。
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      我们始终坚持"用户至上、内容为王、技术驱动"的理念，通过先进的视频编码和CDN加速技术，确保每一位用户都能享受到高清流畅的观影体验。同时，我们郑重承诺：平台所有内容完全免费，全程无广告干扰。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-foreground-900 font-heading mb-4">核心价值观</h2>
                  <div className="space-y-4">
                    {[
                      {
                        icon: 'ri-heart-line',
                        title: '用户至上',
                        desc: '一切以用户体验为中心，持续优化产品功能和服务质量，让追剧变得更加简单快乐。',
                      },
                      {
                        icon: 'ri-shield-check-line',
                        title: '品质保障',
                        desc: '坚持高清画质标准，采用先进编码技术，确保每一帧画面都清晰流畅。',
                      },
                      {
                        icon: 'ri-lightbulb-line',
                        title: '持续创新',
                        desc: '不断探索新技术和新模式，为用户带来更智能、更便捷的追剧体验。',
                      },
                      {
                        icon: 'ri-team-line',
                        title: '开放合作',
                        desc: '与优质内容方建立深度合作，为用户提供最全面、最新鲜的电视剧资源。',
                      },
                    ].map((item, index) => (
                      <div key={index} className="flex gap-4 items-start">
                        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                          <i className={`${item.icon} text-lg`}></i>
                        </div>
                        <div>
                          <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                          <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mb-14">
                <h2 className="text-xl font-bold text-foreground-900 font-heading mb-4">用户口碑</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {[
                    {
                      name: '追剧小王',
                      rating: 5,
                      comment: '天堂影视真的是追剧党的福音！画质清晰、播放流畅、完全免费，没有任何广告打扰，已经推荐给了身边所有朋友。',
                      date: '2024年6月',
                    },
                    {
                      name: '影视爱好者',
                      rating: 5,
                      comment: '用了快两年了，资源非常丰富，热门剧集更新速度也很快。比那些收费的APP好用多了，良心平台！',
                      date: '2024年5月',
                    },
                    {
                      name: '追风少年',
                      rating: 5,
                      comment: '界面简洁美观，操作方便，手机电脑都能看。最重要的是真的完全免费无广告，这在现在的互联网时代太难得了。',
                      date: '2024年7月',
                    },
                  ].map((review, index) => (
                    <div
                      key={index}
                      className="p-5 rounded-lg bg-background-100 border border-background-200/70"
                    >
                      <div className="flex items-center gap-1 mb-3">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                        "{review.comment}"
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-foreground-900">{review.name}</span>
                        <span className="text-xs text-foreground-400">{review.date}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl font-bold text-foreground-900 font-heading mb-4">联系我们</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">contact@tiantangyingshi.com</p>
                      <p className="text-xs text-foreground-400 mt-1">24小时内回复</p>
                    </div>
                  </div>
                  <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                      <i className="ri-customer-service-2-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                      <p className="text-sm text-foreground-500">7×24小时全天候在线</p>
                      <p className="text-xs text-foreground-400 mt-1">即时响应</p>
                    </div>
                  </div>
                  <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                      <i className="ri-feedback-line text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
                      <p className="text-sm text-foreground-500">对我们的产品有任何建议</p>
                      <p className="text-xs text-foreground-400 mt-1">欢迎随时反馈</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}